export default __webpack_public_path__ + "59a42406b6a8472c8fd3fce187d5b639.webp";